/*! Agile Pixel https://agilepixel.io - 2026*/

export default string => `${string.charAt(0).toLowerCase()}${string.replace(/[\W_]/g, '|').split('|')
    .map(part => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join('')
    .slice(1)}`;
